export default function canonicalUrl(
  path: string,
  query: string,
  forQrCode = false,
) {
  let normalizedPath = `/${path}/`.replaceAll(/\/{2,}/g, "/");
  const normalizedQuery = `?${query}`.replaceAll(/^\?{2,}/g, "?");

  if (forQrCode) {
    normalizedPath = normalizedPath.replace(/^\//, "/qrcode/");
  }

  return (
    import.meta.env.VITE_SITE_HOST.replaceAll(/\/+$/g, "") +
    normalizedPath +
    (normalizedQuery && normalizedQuery !== "?" ? normalizedQuery : "")
  );
}
